import STRINGS from '../../common/strings/strings';
import Helper from '../../apis/Helper';

export function validateProposalFormData(documentProposalData, fieldName) {
    const {title,metatitle} = documentProposalData;
    let errorMsg = ''; let errors = {}; let formVaildCheck = true;

        
        if (title === '' && (fieldName == 'title' || fieldName == '')) {
            errorMsg = title === '' ? STRINGS.titleReq :''
            errors.title = errorMsg;
            formVaildCheck = false;
        }

                
        // if (metatitle === '' && (fieldName == 'metatitle' || fieldName == '')) {
        //     errorMsg = metatitle === '' ? STRINGS.metaReq : '';
        //     errors.metatitle = errorMsg;
        //     formVaildCheck = false;
        // }
    
     

    return { formValidCheck: formVaildCheck, errors: errors };
}